module.exports = __webpack_public_path__ + "lp/img/folder_icon_add.c6545d33.svg";